import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { transformMinutesInHours } from 'Components/widgets/transport-details/transportUtils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
type TransportDetailsTravelSectionStopProps = {
  type: 'stop' | 'connection' | 'technicalStop';
  durationInMin?: string | null;
};
export function TransportDetailsTravelSectionStop({
  type,
  durationInMin,
}: TransportDetailsTravelSectionStopProps) {
  const { isRTL } = useResponsive();
  const stop = durationInMin ? transformMinutesInHours(durationInMin, isRTL) : null;
  return (
    <div
      data-testid="TransportDetailsTravelSectionStop"
      className={classnames('my-20 rounded-12 border-1 border-grey px-20 py-10', {
        ['border-orange']: type !== 'technicalStop',
      })}
    >
      <div className="flex items-center gap-20 text-14 leading-tight">
        {stop && <span className="text-orange">{stop}</span>}
        {type === 'technicalStop' ? (
          <span className="font-semibold text-black">{t('common.transport.technicalStop')}</span>
        ) : (
          <span className="text-orange">{t('common.transport.connection')}</span>
        )}
      </div>
      {type === 'connection' && (
        <div className="mt-10 flex items-center gap-20">
          <Icon className="shrink-0 text-orange" name={ICONS.INFORMATION} width="1.5rem" />
          <span className="text-14 leading-tight text-orange">
            {t('booking.transport.stopoverAirportChange')}
          </span>
        </div>
      )}
    </div>
  );
}
